import React, { useState } from 'react';
import { store } from 'react-notifications-component';
import * as S from './styles';
import InputV3 from '../input/novo/input_v3';
import InputSign from '../inputSign';
import api from '../../services/api';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';
import validadorCpfCnpj from '../../services/validadorCpfCnpj';
import { BodyM, TaglineM } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';

import mais from "../../assets/Mais.png";
import { IconUploads } from "../../assets/icons/iconUploads";

import {Loading} from '../loading';

const formatCPF = (value) => {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  return value;
};

export default function RegisterAgronomist({ onSuccess, onCancel }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [cpf, setCpf] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [assinatura, setAssinatura] = useState('');
  const [tipo, setTipo] = useState('');
  const [renderInput, setRenderInput] = useState(false);
  const [namesfiles, setNamesfiles] = useState([]);
  const [file, setFile] = useState("");
  const [textFile, setTextFile] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({ name: false, email: false, cpf: false, whatsapp: false });
  const [cpfErrorMsg, setCpfErrorMsg] = useState('');
  const [digital, setDigital] = useState(false);
  const [eletronica, setEletronica] = useState(false);
  const [manual, setManual] = useState(false);


  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.(com|com\.br|net|org|org\.br)$/.test(email.trim());
  const validatePhone = (phone) => phone.replace(/\D/g, '').length >= 10;
  const validateCPF = (cpf) => cpf.replace(/\D/g, '').length === 11;

  const validate = async () => {
    const err = {
      name: !name.trim(),
      email: !validateEmail(email),
      cpf: !validateCPF(cpf),
      whatsapp: !validatePhone(whatsapp)
    };

    if (!err.cpf) {
      const resultado = await validadorCpfCnpj(cpf);
      if (!resultado.valido) {
        err.cpf = true;
        setCpfErrorMsg(resultado.erro || 'Informe um CPF válido.');
      } else {
        setCpfErrorMsg('');
      }
    } else {
      setCpfErrorMsg('Informe um CPF.');
    }

    setErrors(err);
    return !Object.values(err).includes(true);
  };

  const handleBlurCpf = async () => {
    if (!cpf.replace(/\D/g, '').trim()) return;

    const resultado = await validadorCpfCnpj(cpf);
    if (!resultado.valido) {
      setErrors(prev => ({ ...prev, cpf: true }));
      setCpfErrorMsg(resultado.erro || 'Informe um CPF válido.');
    } else {
      setErrors(prev => ({ ...prev, cpf: false }));
      setCpfErrorMsg('');
    }
  };

  const formatPhone = (value) => {
    if (!value) return "";
    value = value.replace(/\D/g, "");
    if (value.length <= 10) {
      value = value.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
    } else {
      value = value.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
    }
    return value.trim();
  };

  const handleSave = async () => {
    if (!(await validate())) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
      return;
    }

    setIsLoading(true);
    try {
      await api.post("/agronomos", {
        nome: name,
        email,
        cpf,
        whatsapp,
        enviar_receita: 0,
        assinatura: tipo === 'E' ? assinatura : '',
      });
      onSuccess();
      store.addNotification({
        title: "Sucesso!",
        message: `Responsável técnico adicionado com sucesso`,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    } catch (err) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(err, "ERRO-551 Erro ao salvar - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    } finally {
      setIsLoading(false);
    }
  };

  const tipoAssinatura = (value) => {
    setTipo(value);
    setDigital(value === 'D');
    setEletronica(value === 'E');
    setManual(value === 'M');
  };

  const deleteFile = () => {
    setNamesfiles([]);
    setFile("");
    setTextFile("");
  };

  const onChangeCertificate = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      setNamesfiles([file.name]);
    }
  };

  const editSign = (value) => {
    setAssinatura(value);
  };

  return (
    <S.ContainerModalAddAgronomist>
      <BodyM fontWeight={800}>Cadastre um novo responsável técnico</BodyM>
      <InputV3
        floatingLabelWithAsterisk="Nome do responsável técnico"
        value={name}
        onChange={(e) => setName(e.target.value)}
        hasError={errors.name}
      />
      <InputV3
        floatingLabelWithAsterisk="E-mail"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        hasError={errors.email}
      />
      <InputV3
        floatingLabelWithAsterisk="CPF"
        value={formatCPF(cpf)}
        onChange={(e) => setCpf(e.target.value.replace(/\D/g, '').slice(0, 11))}
        onBlur={handleBlurCpf}
        hasError={errors.cpf}
        errorInfo={cpfErrorMsg}
        maxLength={14}
      />
      <InputV3
        floatingLabelWithAsterisk="Whatsapp"
        value={formatPhone(whatsapp)}
        onChange={(e) => setWhatsapp(e.target.value.replace(/\D/g, '').slice(0, 11))}
        hasError={errors.whatsapp}
        maxLength={15}
      />

      <div className="radios" style={{ display: "flex", gap: "5px" }}>
        <input
          type="radio"
          id="m"
          name="fav_language"
          value="M"
          onChange={(e) => tipoAssinatura(e.target.value)}
        ></input>
        <label for="m">Assinatura Manual</label>
        <input
          type="radio"
          id="d"
          name="fav_language"
          value="D"
          onChange={(e) => tipoAssinatura(e.target.value)}
        ></input>
        <label for="d">Assinatura Digital</label>
        <input
          type="radio"
          id="e"
          name="fav_language"
          value="E"
          onChange={(e) => tipoAssinatura(e.target.value)}
        ></input>
        <label for="e">Assinatura Eletrônica</label>
      </div>

      {digital ? (
        <>
          <S.Assinaturas>
            Assinatura Digital é aquela que precisa de um certificado A1
            válido. Aceita nos estados MT, PR, SC, RS, GO, MG, ES, SP e
            MS.
          </S.Assinaturas>
          <div class="input-wrapper">
            <label
              style={{
                paddingLeft: "15px",
                textAlign: "left",
                fontSize: "12px",
                fontWeight: 700,
                color: "#8a92a2",
              }}
            >
              Upload certificado digital
            </label>
            <div className="arquivos">
              <label
                className="btn-update"
                for="input-file"
                multiple
                onClick={() => {
                  setRenderInput(true);
                }}
              >
                <IconUploads
                  width="auto"
                  height="40px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                />
                Selecione o arquivo PFX em seu computador.<br></br>
                <br></br>O upload do certificado é necessário caso deseje
                assinar sua receita digitalmente.{" "}
                <label className="arq-name">
                  {namesfiles.length > 0 ? (
                    <>
                      {namesfiles}
                      <img
                        src={mais}
                        width="20"
                        height="20"
                        onClick={() => deleteFile()}
                        alt="Mais"
                      />
                    </>
                  ) : (
                    "Nenhum arquivo selecionado"
                  )}{" "}
                </label>
              </label>
            </div>

            {renderInput ? (
              <input
                style={{ display: "none" }}
                type="file"
                id="input-file"
                name="file"
                multiple
                onChange={(e) => onChangeCertificate(e)}
              />
            ) : null}
          </div>
        </>
      ) : eletronica ? (
        <>
          <S.Assinaturas>
            Assinatura Eletrônica é aquela que utiliza um conjunto de
            dados digitais para validação. Aceita em todos os estados
            brasileiros, exceto MT, PR, SC e RS.
          </S.Assinaturas>
          <InputSign sign={assinatura} update={(e) => editSign(e)} />
        </>
      ) : manual ? (
        <>
          <S.Assinaturas>
            Assinatura Manual é aquela onde você assina à próprio punho.
            Aceita em todos os estados brasileiros.
          </S.Assinaturas>
        </>
      ) : null}

      <S.ContainerButtonsModal>
        <S.ButtonCancelModal onClick={onCancel}>
          <TaglineM fontWeight={theme.typography.fontWeight.extraBold} color={theme.colors.green.Verde_AgroReceita}>
            Cancelar
          </TaglineM>
        </S.ButtonCancelModal>

        <S.ButtonSavedModal onClick={handleSave}>
          <TaglineM fontWeight={theme.typography.fontWeight.extraBold} color={theme.colors.white.Branco}>
            {isLoading ? <Loading size="20px" color={theme.colors.white.Branco}/> : "Salvar"}
          </TaglineM>
        </S.ButtonSavedModal>
      </S.ContainerButtonsModal>
    </S.ContainerModalAddAgronomist>
  );
}
